// extracted by mini-css-extract-plugin
export var arrows = "_5k-6";
export var decrementer = "_5k-a";
export var disabled = "_5k-4";
export var error = "_5k-1";
export var hiddenText = "_5k-b";
export var incrementer = "_5k-9";
export var input = "_5k-8";
export var inputWrapper = "_5k-0";
export var leadingIcon = "_5k-c";
export var readonly = "_5k-3";
export var regular = "_5k-7";
export var small = "_5k-5";
export var warning = "_5k-2";